/**
 * Part-related event handlers for canvas interactions
 * Extracted from MyCanvas.js to reduce file size
 */

/**
 * Creates cancel part edit handler
 * @param {Function} setEditingPartId - Function to set editing part ID
 * @param {Function} setEditedPartData - Function to set edited part data
 * @returns {Function} Handler function for canceling part edit
 */
export const createCancelPartEditHandler = (
  setEditingPartId,
  setEditedPartData
) => {
  return () => {
    setEditingPartId(null);
    setEditedPartData({});
  };
};

/**
 * Creates input change handler for part form
 * @param {Object} newPart - Current new part data
 * @param {Function} setNewPart - Function to set new part data
 * @returns {Function} Handler function for input changes
 */
export const createInputChangeHandler = (newPart, setNewPart) => {
  return (e) => {
    setNewPart({ ...newPart, [e.target.name]: e.target.value });
  };
};

/**
 * Helper function for shallow comparison of part arrays based on part_id
 * @param {Array} arr1 - First array to compare
 * @param {Array} arr2 - Second array to compare
 * @returns {boolean} True if arrays are equal
 */
export const arePartsArraysEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) return false;
  const ids1 = new Set(arr1.map((p) => p.part_id));
  const ids2 = new Set(arr2.map((p) => p.part_id));
  if (ids1.size !== ids2.size) return false;
  for (const id of ids1) {
    if (!ids2.has(id)) return false;
  }
  return true;
};
